/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Image, Space } from "antd";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { NavLink, Link } from "react-router-dom";
import { exportCommonFile, groupBy, getColumnWidth, currencyFormat } from "../../../../../helpers/utilities";
import { Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from '@mui/lab';
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { scheduleLinesHead } from "../../../../../config/constant";
import { TableCell, TableRow, TextField, Typography } from '@mui/material';
import usePrevious from "../../../../Shared/components/Previous";
import { AESEncrypt } from "../../../../../helpers/Crypto";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";


export default function ScheduleLines(props) {
    const { classes, clsx, details, loadMore, instanceDetails } = props;
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const [value, setValue] = useState("");
    const [workFlowGroup, setWorkFlowGroup] = useState({});
    const [list, setList] = useState([]);
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchSearchFilter();
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchSearchFilter();
                }, 500);
            }
        }
    }, [search]);


    useEffect(() => {
        if (details && details?.length > 0) {
            dispatchSearchFilter();
        }
    }, [details]);


    const dispatchSearchFilter = () => {
        let a = details;
        if (search !== '') {
            a = details?.filter((el) => {
                return (el?.customer?.name?.match(new RegExp(search, "i")) ||
                    el?.customer?.serialNo?.match(new RegExp(search, "i")) ||
                    el?.workflow?.name?.match(new RegExp(search, "i")) ||
                    el?.product?.productName?.match(new RegExp(search, "i")) ||
                    el?.product?.productId?.match(new RegExp(search, "i")) ||
                    el?.unit?.name?.match(new RegExp(search, "i")))
            });
        }
        setList(a);
        let groupDetails = groupBy(a, 'workflowId');
        setWorkFlowGroup(groupDetails);
        if (Object.keys(groupDetails).length > 0) {
            for (let [, item] of Object.entries(groupDetails)) {
                setValue(item[0]?.workflow?.name); break;
            }
        }
    }


    return (
        <>
            <Row>
                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                    <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                        <TextField autoComplete='one-time-code'
                            placeholder='Search'
                            type='search'
                            value={search}
                            className={classes.comInput}
                            required
                            variant={'standard'}
                            onChange={(e) => setSearch(e.target.value)}
                            fullWidth
                            onFocus={() => setIconAnimation(true)}
                            onBlur={() => setIconAnimation(false)}
                        />
                        <Image src={SearchIcon} preview={false} />
                        {
                            search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                <Image
                                    src={ClearIcon}
                                    preview={false}
                                />
                            </NavLink>
                        }
                    </div>

                </Col>
                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.allCustomerTop)}>
                    <div className={classes.overlFlowResponsiveDesign}>
                        <Space size={[20, 20]} direction="horizontal" align="center">
                            <NavLink
                                to="#"
                                onClick={() => exportCommonFile('Schedule Lines', list, 'existing', [])}
                                className={clsx(classes.customLink)}>
                                <Image
                                    src={ExportIcon}
                                    preview={false}
                                    className={clsx(classes.antImage)}
                                /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                            </NavLink>
                        </Space>
                    </div>
                </Col>
            </Row>
            <Box className={clsx(classes.tabDesign, classes.margin20t)}>
                {
                    !loadMore ? <div style={{ textAlign: "center" }}>
                        <div className={classes.loadMoreCircle}></div>
                    </div> : <>
                        {
                            workFlowGroup && Object.keys(workFlowGroup).length > 0 ?
                                <TabContext className={classes.viewBatchLines} value={value}>
                                    <TabList onChange={(event, newValue) => handleChange(event, newValue)}>
                                        {
                                            Object?.entries(workFlowGroup)?.map(([key, value]) => (
                                                <Tab key={key} className={classes.Bordertab_1} label={value[0]?.workflow?.name} value={value[0]?.workflow?.name} />
                                            ))
                                        }
                                    </TabList>
                                    {
                                        Object?.entries(workFlowGroup)?.map(([key, value]) => {
                                            let iDetails = instanceDetails && instanceDetails?.filter((el) => el.workflowId === value[0]?.workflowId);
                                            return (
                                                <TabPanel key={key} className={classes.viewBatchLines} value={value[0]?.workflow?.name}>
                                                    {
                                                        iDetails && iDetails?.length > 0 && <Row>
                                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Status </Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{iDetails[0]?.schedule_status || '---'}</Typography>
                                                            </Col>
                                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                                {
                                                                    (iDetails[0]?.selfBillId || iDetails[0]?.salesOrderId) && <>
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>{iDetails[0]?.selfBillId ? 'Sales Bill' : 'Order'} </Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                                            <Link to={`/sales/sales-management/self-bill/${AESEncrypt(iDetails[0]?.selfBillId)}/schedule-view`}>
                                                                                View {iDetails[0]?.selfBillId ? 'Bill' : 'Order'}
                                                                            </Link>
                                                                        </Typography>
                                                                    </>
                                                                }
                                                            </Col>
                                                        </Row>
                                                    }
                                                    <CustomInfiniteScroll
                                                        loadMore={loadMore}
                                                        heads={scheduleLinesHead}
                                                        width={true}
                                                        customClasses={classes.margin30t}
                                                        component={<>
                                                            {
                                                                value.length > 0 ? value.map((data, i) => (
                                                                    <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                                        <TableCell style={{ width: getColumnWidth(scheduleLinesHead, 1) }}><span style={{ width: getColumnWidth(scheduleLinesHead, 1) }}>{data?.product?.productName || '---'}</span></TableCell>
                                                                        <TableCell style={{ width: getColumnWidth(scheduleLinesHead, 2) }}><span style={{ width: getColumnWidth(scheduleLinesHead, 2) }}>{data?.product?.productId || '---'}</span></TableCell>
                                                                        <TableCell style={{ width: getColumnWidth(scheduleLinesHead, 4) }}><span style={{ width: getColumnWidth(scheduleLinesHead, 4) }}>{data?.quantity || '---'}</span></TableCell>
                                                                        <TableCell style={{ width: getColumnWidth(scheduleLinesHead, 5) }}><span style={{ width: getColumnWidth(scheduleLinesHead, 5) }}>{data?.unit?.name || '---'}</span></TableCell>
                                                                        <TableCell style={{ width: getColumnWidth(scheduleLinesHead, 6) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(scheduleLinesHead, 6) }}>{data?.amount ? `₹ ${currencyFormat(data?.amount)}` : '---'}</span></TableCell>
                                                                    </TableRow>
                                                                )) : (
                                                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                                        <TableCell className={classes.textAlignCenter} colSpan={scheduleLinesHead.length}>
                                                                            <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>There are no results available for the searched query</p>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )
                                                            }
                                                        </>}
                                                    />
                                                </TabPanel>
                                            )
                                        })
                                    }
                                </TabContext> : <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>There are no results available for the searched query</p>
                        }
                    </>

                }
            </Box>

        </>
    )
}

